import React from "react";
import PropTypes from "prop-types";
import AppContext from "./Context/AppContext";
import EditorContext from "./Context/EditorContext";
import OfflineContext from "./Context/OfflineContext";
import PlayerView from "./Components/PlayerView";

export const PlayerContextType = {
    EDITOR: "editor",
    APP: "app",
    OFFLINE: "offline"
};

function getContext(playerContextType) {
    if (playerContextType === PlayerContextType.EDITOR) {
        return EditorContext;
    }

    if (playerContextType === PlayerContextType.APP) {
        return AppContext;
    }

    if (playerContextType === PlayerContextType.OFFLINE) {
        return OfflineContext;
    }

    throw new Error(`Unknown player context type ${playerContextType}`);
}

class Player extends React.Component {
    static propTypes = {
        // Required prop
        contextType: PropTypes.string.isRequired,

        // Optional props
        onExit: PropTypes.any,
        startSlideIndex: PropTypes.number,
        openPresenterOnPlaybackStarted: PropTypes.bool,
        enterFullscreenOnPlaybackStarted: PropTypes.bool,

        // Optional editor context specific props
        presentation: PropTypes.object,
        isOpenedFromMainView: PropTypes.bool,
    }

    static defaultProps = {
        // Default values for optional props
        onExit: false,
        startSlideIndex: 0,
        openPresenterOnPlaybackStarted: false,
        enterFullscreenOnPlaybackStarted: false,
        presentation: null,
        isOpenedFromMainView: false,
    }

    render() {
        const Context = getContext(this.props.contextType);
        return (
            <Context {...this.props}>
                {contextData => (
                    <PlayerView
                        {...this.props}
                        // Note: context may ovveride props values (e.g. presentation) so it goes after
                        {...contextData}
                    />
                )}
            </Context>
        );
    }
}

export default Player;
